"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initBsiManager = exports.callSafeCommonConfig = void 0;
var manager_slave_1 = require("@wix/bsi-manager/dist/src/manager-slave");
var consent_policy_client_accessor_1 = require("@wix/consent-policy-client-accessor");
var BsiManagerKey = '__bsiManager';
var callSafeCommonConfig = function (Wix, fn) {
    var _a;
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return Wix.Utils.commonConfig &&
        typeof Wix.Utils.commonConfig[fn] === 'function' && (_a = Wix.Utils.commonConfig)[fn].apply(_a, args);
};
exports.callSafeCommonConfig = callSafeCommonConfig;
var createBsiManager = function (Wix) {
    var policyAccessor = new consent_policy_client_accessor_1.ConsentPolicyAccessor();
    var callSafe = function (fn) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return exports.callSafeCommonConfig.apply(void 0, __spreadArray([Wix, fn], args, false));
    };
    return new manager_slave_1.SlaveBsiManager().init({
        getCommonConfig: function () { return ({
            get: function (key) { return callSafe('get', key); },
            subscribe: function (handler) { return callSafe('onCommonConfigChanged', handler); },
        }); },
        getConsentPolicy: function () { return ({
            policy: policyAccessor.getCurrentConsentPolicy(),
        }); },
    }, { enableCookie: true });
};
var initBsiManager = function () {
    if (typeof window === 'undefined' ||
        !window.Wix ||
        window.self === window.top) {
        return null;
    }
    if (!window[BsiManagerKey]) {
        window[BsiManagerKey] = {
            manager: createBsiManager(window.Wix),
            getBsi: function () {
                var Analytics = window.Wix.Analytics;
                if (Analytics &&
                    typeof Analytics.reportVisitorActivity === 'function') {
                    Analytics.reportVisitorActivity();
                }
                return this.manager.getBsi();
            },
        };
    }
    return window[BsiManagerKey];
};
exports.initBsiManager = initBsiManager;
//# sourceMappingURL=bsi.js.map